// Importación de Axios
import axios from "axios";
import { RUTA_SERVIDOR_BACKEND } from "./configuraciones";

export const getDashboard = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/dashboard`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const getContadorBooking = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/contadorBookings`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);
